import * as Yup from "yup"

import { getEventTitleInfoValidations } from "../helpers"

export const validationSchema = Yup.object().shape({
  departure_date: Yup.date().nullable().required("field.error.required"),
  ...getEventTitleInfoValidations(),
})
